<template>
  <div>
    <div class="title_box1_training">
    </div>
    <div class="msgg_box">
      <div class="one_nav_msg">
        <div class="big_line1">
          <div class="small_line2"></div>
        </div>
        <div class="textbook_title" @click="shouye()">首页 </div>
        <span class="jixu">>信息公布</span>
      </div>
      <div class="box_two">
        <div class="two_nav_msg">
          <div class="two_msg_title">
            <img
                class="two_msg_img"
                src="../../../assets/img/home/xinwen.png"
                alt=""
            />
            <span class="two_msg_title_1">信息公布</span>
          </div>
          <div
              class="three_nav_msg"
              v-for="(item, index) in MajorArr"
              :key="index"
          >
            <div
                :class="[
                                { dong_msg: num == index },
                                { dong_msg1: num !== index },
                            ]"
            ></div>
            <div
                :class="[
                                { xinxi_msg_nav: num == index },
                                { xinxi_msg_nav1: num !== index },
                            ]"
                @click="cl(index, item.id)"
            >
              {{ item }}
            </div>
          </div>
        </div>
      </div>
      <div class="ttl" v-show="num == 0">
        <!-- <div class="tit">
            <div>类型</div>
            <div @click="cur = 0" :class="{ active: cur == 0 }">
                全部
            </div>
            <div @click="cur = 1" :class="{ active: cur == 1 }">
                公告
            </div>
            <div @click="cur = 2" :class="{ active: cur == 2 }">
                培训通知
            </div>
            <div @click="cur = 3" :class="{ active: cur == 3 }">
                教材征订通知
            </div>
            <div @click="cur = 4" :class="{ active: cur == 4 }">
                技能鉴定
            </div>
        </div> -->
        <div class="tt0" v-show="cur == 0">
          <div class="zziiz">通知公告</div>
          <div v-if="!flagg">
            <div class="gong" v-for="(item, index) in arr" :key="index">
              <div class="tttt" @click="tzdetail(item.id)">
                <div  class="gong_q">{{ item.title }}</div>
              </div>
              <div class="gong_e" >
                <div class="gong_r">{{ item.type==0?"通知公告":item.type==1?"办事指南":''}}</div>
                <div>{{ shijiantime(item.createTime) }}</div>
              </div>
            </div>
            <div class="ivu-mt ivu-text-center">
                <Page :total="dataCount" :page-size="maxPage" :current.sync="curPage" show-total class="paging" @on-change="changepage" ></Page>
            </div>
          </div>

          <div v-else class="hq"><h1>很抱歉！暂无通知</h1></div>
        </div>
        <!-- <div class="tt0" v-show="cur == 1">
            <div class="gong" v-for="(item, index) in arr" :key="index">
                <div style="margin-top: 10px">
                    <span v-html="item.content" class="gong_q"></span>
                    <span class="gong_w">{{
                        item.pushOrganization
                    }}</span>
                </div>
                <div
                    class="gong_e"
                    style="margin-left: 600px; margin-top: -30px"
                >
                    <span class="gong_r">{{ item.title }}</span
                    ><br />
                    <span>{{ item.createTime }}</span>
                </div>
            </div>
        </div>
        <div class="tt0" v-show="cur == 2">
            <div class="gong" v-for="(item, index) in arr" :key="index">
                <div style="margin-top: 10px">
                    <span v-html="item.content" class="gong_q"></span>
                    <span class="gong_w">{{
                        item.pushOrganization
                    }}</span>
                </div>
                <div
                    class="gong_e"
                    style="margin-left: 600px; margin-top: -30px"
                >
                    <span class="gong_r">{{ item.title }}</span
                    ><br />
                    <span>{{ item.createTime }}</span>
                </div>
            </div>
        </div>
        <div class="tt0" v-show="cur == 3">
            <div class="gong" v-for="(item, index) in arr" :key="index">
                <div style="margin-top: 10px">
                    <span v-html="item.content" class="gong_q"></span>
                    <span class="gong_w">{{
                        item.pushOrganization
                    }}</span>
                </div>
                <div
                    class="gong_e"
                    style="margin-left: 600px; margin-top: -30px"
                >
                    <span class="gong_r">{{ item.title }}</span
                    ><br />
                    <span>{{ item.createTime }}</span>
                </div>
            </div>
        </div>
        <div class="tt0" v-show="cur == 4">
            <div class="gong" v-for="(item, index) in arr" :key="index">
                <div style="margin-top: 20px">
                    <span v-html="item.content" class="gong_q"></span>
                    <span class="gong_w">{{
                        item.pushOrganization
                    }}</span>
                </div>
                <div class="gong_e" style="margin-left: 600px; margin-top: -30px">
                    <span class="gong_r">{{ item.title }}</span><br />
                    <span>{{ item.createTime }}</span>
                </div>
            </div>
        </div> -->
      </div>

      <div class="zx" v-show="num == 1">
        <div class="zziiz">办事指南</div>
        <div v-if="arr2.length">
          <div class="gong" v-for="(item, index) in arr2" :key="index">
            <div class="tttt" @click="tzdetail(item.id)">
              <div  class="gong_q">{{ item.title }}</div>
            </div>
            <div class="gong_e" >
              <div class="gong_r">{{ item.type==0?"通知公告":item.type==1?"办事指南":''}}</div>
              <div>{{ shijiantime(item.createTime) }}</div>
            </div>
          </div>
          <div class="ivu-mt ivu-text-center">
                <Page :total="dataCount2" :page-size="maxPage" :current.sync="curPage2" show-total class="paging" @on-change="changepage2" ></Page>
            </div>
        </div>
        <div v-else class="hq"><h1>很抱歉！暂无办事指南</h1></div>


      </div>
      <div class="zx" v-show="num == 2">
        <div class="zziiz">在线咨询介绍</div>
        <div class="biao">
          <div class="gongz">
            公众可以就自己关心的话题或者疑问进行留言。留言将由培训中心相关部门予以解答，具有代表性的留言主题将给予公开
          </div>
          <el-input
              class="input1"
              placeholder="请输入内容"
              prefix-icon="el-icon-search"
              v-model="input2"
          ></el-input
          ><el-button type="primary" class="www" @click="getre()"
        >查查常见问题</el-button
        >
          <img @click="liuyan"
               src="../../../assets/img/home/liuyan.png"
               alt=""
               class="liuyan"
          />
          <div class="tijianzix">
            <div class="kn">您可能是想咨询:</div>
            <div class="tyu" v-for="(item,index) in tuijianzix" :key="index">
              <div class="meigge" @click="tuijian(item.labelName)"  >{{item.labelName}}</div>
<!--              <div class="meigge" @click="tuijian(item)"  >{{item}}</div>-->
            </div>
          </div>
        </div>
        <div class="biao2" ref="rrr">
          <div class="zziiz">咨询热点（FAQ）</div>
          <div class="refu">
            <div class="redian"  v-for="(item, index) in redian" :key="index">
              <div class="dianv"></div>
              <div @click="getdetail(item.id)" class="itll">{{ item.title }}</div>
              <div class="jianqq">{{ shijiantime(item.leaveTime) }}</div>
            </div>
          </div>
        </div>
        <div class="biao3" ref="ccc">
          <div class="zziiz">查询信息</div>

          <div class="refu" v-if="!flag">
            <div
                class="redian"
                v-for="(item, index) in redian"
                :key="index"
            >
              <div class="dianv"></div>
              <div @click="getdetail(item.id)" class="itll">{{ item.title }}</div>
              <div class="jianqq">{{ shijiantime(item.leaveTime)}}</div>
            </div>
          </div>
          <div v-else class="hq"><h1>很抱歉！无搜索结果</h1></div>
        </div>
        <div class="biao4" ref="zzz">
          <div class="zziiz">咨询列表</div>

          <div class="refu">
            <div class="redian"  v-for="(item, index) in zxlb" :key="index">
              <div class="dianv"></div>
              <div class="itll" @click="getdetail(item.id)">{{ item.title }}</div>
              <div class="jianqq">{{ shijiantime(item.leaveTime) }}</div>
            </div>
          </div>
        </div>

        <div class="btn"></div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  queryAllNotice,
  queryGuestbookList,
  queryGuestbook,
  queryLabelList,
} from "network/home";
import { DebounceBy } from "common/utils";
export default {
  data() {
    return {
      flagg:false,
      flag: false,
      num: 0,
      MajorArr: ["通知公告", "办事指南", "咨询FAQ"],
      curPage: 1, //当前页码
      curPage2: 1, //当前页码
      maxPage: 10, //每页最大条数
      type: 0,
      cur: 0,
      activeName: "second",
      arr: [],
      textarea: "",
      input: "",
      code: 0,
      input2: "",
      redian: [],
      id:'',
      tuijianzix:[],
      zxlb:[],
      arr2:[],
      dataCount:0,
      dataCount2:0
    };
  },
  created() {
    this.queryAnnouncement();
    this.queryGuestbookList()
    this.queryGuestbooks()
    this.queryAnnouncementt()
    this.queryLabelList()
  },
  activated() {},
  //组件创建前调用的生命周期
  beforeCreate() {},
  deactivated() {},
  methods: {
    shouye(){
      this.$router.push("/index")
    },
    shijiantime(times) {
      var newDate = /\d{4}-\d{1,2}-\d{1,2}/g.exec(times);
      return newDate[0];
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },

    cl(index, id) {
      this.num = index;
    },
    queryAnnouncement() {
      queryAllNotice({
        curPage: this.curPage,
        maxPage: this.maxPage,
        type: this.type,
      }).then((r) => {
        console.log(r.data.data.data,"通知公告");
        this.arr = r.data.data.data;
        this.dataCount = r.data.data.total;
        if(!this.arr.length){
          this.flag = true
        } else{
          this.flag = false
        }
      });
    },
    queryAnnouncementt() {
      queryAllNotice({
        curPage: this.curPage2,
        maxPage: this.maxPage,
        type: 1,
      }).then((r) => {
        console.log(r.data.data.data,"办事指南");
        this.arr2 = r.data.data.data;
        this.dataCount2 = r.data.data.total;
      });
    },
    chongzhi() {
      (this.textarea = ""), (this.input = "");
    },
    //咨询列表
    queryGuestbookList(){
      queryGuestbook({
        keyWords: this.input2,
        curPage: this.curPage,
        maxPage: this.maxPage,
      }).then((res)=>{
        console.log(res.data.data,"咨询列表");
        this.zxlb = res.data.data.data
      })
    },
    queryGuestbooks(){
      // 热点：1，非热点 不传
      queryGuestbook({
        keyWords: this.input2,
        isRecommend: 1,
        curPage: this.curPage,
        maxPage: this.maxPage,
      }).then((res) => {
        //    this.$refs.rrr.style.display='none'
        //    this.$refs.ccc.style.display='block'
        //    this.$refs.zzz.style.display='none'
        console.log(res,"热点查询");
        this.redian = res.data.data.data;
      });
    },

    getre: DebounceBy(function () {
      /*写你自己的业务代码*/
      console.log('===getre===')
      if (this.input2 == "") {
        this.$message({
          message: "请先输入查询信息",
          type: "warning",
        });
      } else {
        queryGuestbook({
          keyWords: this.input2,
        }).then((res) => {
          console.log('this.redian===', res);
          this.$refs.rrr.style.display='none'
          this.$refs.ccc.style.display='block'
          this.$refs.zzz.style.display='none'
          console.log('this.redian===', res.data.data.data);
          this.redian = res.data.data.data;
          if(!this.redian.length) { // 没有数据
            this.flag = true
          } else {// 有数据
            this.flag = false
          }
        });
      }
      this.input2=""
    }, 600),
    liuyan(){
      this.$router.push("/liuyan")
    },
    tuijian(item){
      this.input2 = item
      this.getre()
    },
    //通知详情
    tzdetail(id){
      // console.log(id);
      this.$router.push({
        name:"tzdetail",
        params:{
          id:id
        }
      });
    },
    //标签
    queryLabelList(){
      queryLabelList().then((res)=>{
        this.tuijianzix = res.data.data
      })
    },
    getdetail(id){
      // console.log(id)
      this.$refs.rrr.style.display='block'
      this.$refs.zzz.style.display='block'
      this.$refs.ccc.style.display='none'
      this.$router.push({
        name:"zxzxdetail",
        params:{
          id:id
        }
      });
    },
    changepage(index) {
      this.curPage = index;
      this.queryAnnouncement();
    },
    changepage2(index) {
      this.curPage2 = index;
      this.queryAnnouncementt();
    },
    changepagesize(pageSize) {
        this.maxPage = pageSize;
    },
  },
  watch: {},
};
</script>
<style lang="less" scoped>


@import url("../../../assets/css/licss/training.css");
.www{
  background: #3562E8;
}
.tit {
  width: 800px;
  height: 50px;
  background-color: #f7faff;
  line-height: 50px;
  text-align: center;
  display: flex;
  justify-content: space-around;
  margin-left: 100px;
  /* opacity: 0.5; */
  color: black;
  cursor: pointer;
}
.active {
  color: #3562e8;
}

.three_nav_msg {
  width: 200px;
  /* height: 50px; */
}
.tt0 {
  width: 930px;
  height: 800px;
  /* margin-top: 20px; */
  margin-left: 270px;
  background-color: #f7faff;
}
.gong {
  width: 930px;
  // margin-left: 30px;
  // margin-top: 20px;
  display: flex;
  justify-content: space-around;
}
.gong_q {
  width: 700px;
  color: #181818;
  font-size: 16px;
  font-weight: 400px;
  font-family: Microsoft YaHei;
  margin-left: -60px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  /* display: inline-block; */
}
.gong_w {
  color: #999999;
  font-size: 8px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  /* display: inline-block; */
}
.gong_e {
  width: 100px;
  height: 50px;
  text-align: center;
  border-radius: 4px;
}
.gong_r {
  width: 100px;
  color: #286fff;
  background: #dfeaff;


}
.zx {
  width: 900px;
  /* height: 800px; */
  margin-left: 280px;
  background-color: #f7faff;
  position: relative;
}
.kn {
  margin-top: 20px;
  font-size: 12px;
  font-family: Microsoft YaHei;
  // font-weight: 400;
  color: #666666;
}
.inputa {
  width: 400px;
  height: 30px;
}
.input1 {
  width: 560px;
  height: 10px;
}
.refu{
  margin-bottom: 20px;
}

.biao {
  color: #333333;
  font-size: 16px;
  margin-top: 30px;
  margin-left: 60px;
  display: inline-block;
}
.biao2 {
  width: 800px;
  // height: 50px;
  margin-top: 20px;
  margin-bottom: 20px;
  /* margin-left: 205px; */
  color: #333333;
  font-size: 16px;
}
.biao3 {
  width: 800px;
  margin-top: 20px;
  /* margin-left: 205px; */
  color: #333333;
  font-size: 16px;
  display: none;
  cursor: pointer;
}
.liuyan {
  width: 83px;
  height: 80px;
  position: absolute;
  top: 30px;
  right: 30px;
}
/deep/ .el-input__icon{
  color:#4771EA;
}
.gongz {
  width: 700px;
  font-size: 12px;
  font-family: Microsoft YaHei;
  margin-top: 10px;
  // margin-bottom: 5px;
  font-weight: 400;
  color: #181818;
}
.zziiz {
  color: #4771ea;
  font-size: 16px;
  margin-left: 30px;
  padding-top: 20px;
  margin-bottom: 10px;
}
.xbtn {
  width: 55px;
  height: 22px;
  font-size: 14px;
  line-height: 22px;
  text-align: left;
}
.btn {
  margin-left: 300px;
  margin-top: 60px;
}
/* .dian{
    width: 6px;
    height: 6px;
    background: #FF8765;
    border-radius: 50%;
       
} */
.dian {
  width: 6px;
  height: 6px;
  background: #ff8765;
  border-radius: 50%;
  margin-top: 40px;
  margin-left: 20px;
  display: inline-block;
}
.redian {
  font-size: 16px;
  margin-top: -20px;
  margin-bottom: 20px;
  margin-left: 50px;
  width: 800px;
  display: flex;
  justify-content: space-between;
  cursor: pointer;
  text-align: left;

}
.geng {
  width: 40px;
  font-size: 12px;
  margin-top: -20px;
  margin-left: 820px;
  color: #4771ea;
}
.three_nav_msg{
  cursor: pointer;
}
.tijianzix{
  width: 550px;
  display: flex;
  flex-wrap: wrap;
  &>div{
    margin-right: 20px;
  }
}
.tyu{
  margin-top: 20px;
  border: 1px solid #4771EA;
  border-radius: 4px;
  cursor: pointer;
}
.meigge{
  font-size: 14px;
  text-align: center;
  color: #4771EA;
}
.tttt{
  margin-top: 10px;
  margin-left: 50px;
  cursor: pointer;
}
.biao4 {
  width: 200px;
  margin-top: 20px;
}
.itll {
  width: 100px;
  margin-top: 20px;
  margin-left: -620px;
  color: #181818;
  font-size: 16px;
}
.jianqq {
  margin-top: 20px;
  color: #999999;
  font-size: 12px;
}
.dianv {
  width: 6px;
  height: 6px;
  background: #ff8765;
  border-radius: 50%;
  margin-top: 30px;
  // margin-left: 0px;
  display: inline-block;
}
.hq{
  margin-left: 300px;
}
.ivu-text-center {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    justify-content: flex-end;
    margin-top: 20px;
    margin-right: 20px;
}
</style>